<template>
  <div class="main_form_box">
    <div class="main_form_bar">
      <span>请选择人员组：</span>
      <div class="group_list_bar">
        <div
          v-for="item in userGroupList"
          :key="item.MeetingUserGroupID"
          :class="{
            group_item_active: selectUserGroupId === item.MeetingUserGroupID,
            group_item: selectUserGroupId !== item.MeetingUserGroupID
          }"
          @click="groupClick(item.MeetingUserGroupID)"
        >
          <i
            style="margin-right: 0px"
            class="iconfont"
            :class="{
              'icon-danxuanxuanzhong':
                selectUserGroupId === item.MeetingUserGroupID,
              'icon-weixuanzhong': selectUserGroupId !== item.MeetingUserGroupID
            }"
          ></i>
          {{ item.MeetingUserGroupName }}
        </div>
        <el-link
          type="primary"
          :underline="false"
          icon="el-icon-circle-plus-outline"
          @click="editUserGroup(null)"
        >
          新增组
        </el-link>
      </div>
    </div>
    <div class="main_form_body">
      <div class="form_bar">
        <div class="form_bar_search">
          <el-button
            type="primary"
            icon="el-icon-download"
            size="mini"
            @click="exportTemplate()"
            :disabled="questionnaireInfo.State !== 0"
          >
            导出模板
          </el-button>
          <el-button
            type="primary"
            icon="el-icon-upload2"
            size="mini"
            @click="importData()"
            :disabled="questionnaireInfo.State !== 0"
          >
            批量导入
          </el-button>
          <el-button
            type="primary"
            icon="el-icon-plus"
            size="mini"
            @click="editUser(null)"
            :disabled="questionnaireInfo.State !== 0"
          >
            新增人员
          </el-button>
          <el-button
            type="primary"
            icon="el-icon-plus"
            size="mini"
            @click="editExaminer(null)"
            :disabled="questionnaireInfo.State !== 0"
          >
            新增阅卷人
          </el-button>
          <span class="select_message margin_left_20 margin_right_10">
            已选（{{ selectRows.length }}）个人员
          </span>
        </div>
        <div class="form_bar_btn">
          <el-button type="text" @click="goBack()">投票列表</el-button>
          <el-button
            type="primary"
            @click="editQuestionnaireUser(false)"
            size="small"
            :disabled="questionnaireInfo.State !== 0"
          >
            保存
          </el-button>
          <el-button
            type="primary"
            size="small"
            @click="editQuestionnaireUser(true)"
            :disabled="questionnaireInfo.State !== 0"
          >
            下一步
          </el-button>
        </div>
      </div>
      <div class="form_content" style="min-height: 500px">
        <el-table
          ref="multipleTable"
          :data="userList"
          style="width: 100%"
          @selection-change="handleSelectionChange"
          @cell-mouse-leave="leaveCall"
          @row-click="selectRowChange"
          :row-class-name="tableRowClassName"
          stripe
        >
          <el-table-column
            type="selection"
            width="55"
            :selectable="checkSelectable"
          >
          </el-table-column>
          <el-table-column
            type="index"
            label="序号"
            width="60"
          ></el-table-column>
          <el-table-column property="UserName" label="姓名"> </el-table-column>
          <el-table-column property="Phone" label="用户名" align="center">
          </el-table-column>
          <el-table-column label="角色" align="center">
            <template slot-scope="scope">
              <span>
                <i class="el-icon-s-check" v-if="scope.row.RoleId === 7"></i>
                <span v-if="scope.row.RoleId === 0 || scope.row.RoleId === 1">
                  学员
                </span>
                <span v-if="scope.row.RoleId === 7">阅卷人</span>
              </span>
            </template>
          </el-table-column>
          <el-table-column
            property="UserVoteNumber"
            label="权重(票数)"
            align="center"
          >
          </el-table-column>
          <el-table-column property="Sort" label="排序" align="center">
          </el-table-column>
          <el-table-column
            label="操作"
            align="center"
            v-if="userRole === 1 && questionnaireInfo.State === 1"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.IsSubmit"> 已提交 </span>
              <el-link
                type="primary"
                v-if="scope.row.IsSelect && !scope.row.IsSubmit"
                @click="deleteQuestionnaireUser(scope.row)"
              >
                移除
              </el-link>
              <el-link
                type="primary"
                v-if="!scope.row.IsSelect && !scope.row.IsSubmit"
                @click="insertQuestionnaireUser(scope.row)"
              >
                添加
              </el-link>
            </template>
          </el-table-column>
        </el-table>
        <ImportExcel
          :fatherSubmitDialog="importExcelDialog"
          ref="importUser"
        ></ImportExcel>
        <EditUserGroup
          :meetId="meetingId"
          :fatherSubmitDialog="editUserGroupDialog"
          ref="editUserGroup"
        ></EditUserGroup>
        <EditUser
          :MeetingGroupID="selectUserGroupId"
          :MeetingID="meetingId"
          :IsShowHeadPicture="isShowHeadPicture"
          :fatherSubmitDialog="editUserDialog"
          ref="editUser"
        ></EditUser>
        <EditExaminer
          :MeetingGroupID="selectUserGroupId"
          :MeetingID="meetingId"
          :IsShowHeadPicture="isShowHeadPicture"
          :fatherSubmitDialog="editExaminerDialog"
          ref="editExaminer"
        ></EditExaminer>
      </div>
    </div>
  </div>
</template>
<script>
import voteUserApi from '../../../api/vote/voteUser'
import questionnaireApi from '../../../api/wj/questionnaire'
import ImportExcel from '@/components/wj_user/ImportExcel.vue'
import EditUserGroup from '@/components/wj_user/EditUserGroup.vue'
import EditUser from '@/components/wj_user/EditUser.vue'
import EditExaminer from '@/components/wj_user/EditExaminer.vue'
export default {
  name: 'editUser',
  components: {
    ImportExcel,
    EditUserGroup,
    EditUser,
    EditExaminer
  },
  data () {
    return {
      meetingId: null,
      selectUserGroupId: null,
      userGroupList: [],
      groupListQuery: {
        meetingId: null,
        maxResultCount: 1000000,
        skipCount: 0
      },
      userList: [],
      listQuery: {
        meetingGroupID: null,
        maxResultCount: 1000000,
        skipCount: 0
      },
      selectRows: [],
      questionnaireUserInfo: {},
      isShowHeadPicture: false,
      userRole: -1
    }
  },
  props: ['voteInfo', 'meetingInfo', 'questionnaireInfo'],
  inject: ['voteCheck', 'getVoteInfo', 'getQuestionnaireInfo', 'routeChange'],
  methods: {
    goBack: function () {
      this.$router.push({ name: 'meetingVote', params: { mid: this.$route.params.mid } })
    },
    getCurrentUserRole: function () {
      this.$api.userInfo.getCurrentUserRole().then(data => {
        this.userRole = data
      }).catch(err => {
        return err
      })
    },
    getVoteUserGroups: function () {
      const _this = this
      const openLoading = _this.openLoading()
      voteUserApi.getVoteUserGroups(_this.groupListQuery).then(data => {
        _this.userGroupList = data.Items
        _this.getDefaultUserGroup()
        openLoading.close()
      }).catch(err => {
        openLoading.close()
        return err
      })
    },
    getDefaultUserGroup: function () {
      const _this = this
      const openLoading = _this.openLoading()
      voteUserApi.getDefaultUserGroup({
        meetingId: _this.groupListQuery.meetingId
      }).then(data => {
        if (!data) {
          _this.userGroupList.unshift({ MeetingUserGroupID: null, MeetingUserGroupName: '默认组', Sort: 0 })
        }
        if (!_this.selectUserGroupId) {
          if (_this.userGroupList.length > 0) {
            _this.selectUserGroupId = _this.userGroupList[0].MeetingUserGroupID
          }
        }
        _this.listQuery.meetingGroupID = _this.selectUserGroupId
        _this.getQuestionnaireUserInfo()
        openLoading.close()
      }).catch(err => {
        openLoading.close()
        return err
      })
    },
    getQuestionnaireUserInfo: function () {
      const _this = this
      const openLoading = _this.openLoading()
      questionnaireApi.getQuestionnaireUserInfo({
        questionnaireId: _this.$route.params.qid
      }).then(data => {
        _this.questionnaireUserInfo = data
        if (_this.questionnaireUserInfo.UserGroupId) {
          _this.selectUserGroupId = this.questionnaireUserInfo.UserGroupId
          _this.listQuery.meetingGroupID = _this.selectUserGroupId
        }
        _this.getVoteUsers()
        openLoading.close()
      }).catch(err => {
        openLoading.close()
        return err
      })
    },
    getVoteUsers: function () {
      const _this = this
      const openLoading = _this.openLoading()
      voteUserApi.getVoteUsers(_this.listQuery).then(data => {
        _this.userList = data.Items
        if (_this.userList !== null) {
          this.$nextTick(() => {
            _this.userList.forEach(function (row, index) {
              _this.$set(row, 'IsSelect', false)
              if (_this.questionnaireUserInfo.QuestionnaireSelectUsers) {
                _this.questionnaireUserInfo.QuestionnaireSelectUsers.forEach(function (selectItem, index) {
                  if (row.GroupStaffID.toLowerCase() === selectItem.GroupStaffId.toLowerCase()) {
                    _this.$refs.multipleTable.toggleRowSelection(row, true)
                    _this.$set(row, 'IsSubmit', selectItem.IsSubmit)
                    _this.$set(row, 'IsSelect', true)
                  }
                })
              }
            })
          })
        }
        openLoading.close()
      }).catch(err => {
        openLoading.close()
        return err
      })
    },
    groupClick: function (meetingGroupID) {
      this.selectUserGroupId = meetingGroupID
      this.listQuery.meetingGroupID = this.selectUserGroupId
      this.getVoteUsers()
    },
    handleSelectionChange: function (val) {
      this.selectRows = val
    },
    hoverCall: function (row, column, cell, event) {
      if (event.which === 1) {
        this.$refs.multipleTable.toggleRowSelection(row)
      }
    },
    leaveCall: function (row, column, cell, event) {
      if (event.which === 1) {
        this.$refs.multipleTable.toggleRowSelection(row)
      }
    },
    selectRowChange: function (row, column, event) {
      this.$refs.multipleTable.toggleRowSelection(row)
    },
    checkSelectable: function (row) {
      if (this.questionnaireInfo.State !== 0) {
        return false
      } else {
        return true
      }
    },
    tableRowClassName ({ row, rowIndex }) {
      return ''
    },
    importData: function () {
      this.$refs.importUser.openImportExcel(this.selectUserGroupId, this.$route.params.mid)
    },
    importExcelDialog: function () {
      this.getVoteUserGroups()
    },
    editUserGroup: function (userGroupID) {
      this.$refs.editUserGroup.openEditUserGroup(userGroupID)
    },
    editUserGroupDialog: function () {
      this.getVoteUserGroups()
    },
    editUser: function (groupStaffId) {
      this.isShowHeadPicture = true
      this.$refs.editUser.openEditUser(groupStaffId)
    },
    editUserDialog: function () {
      this.getVoteUserGroups()
    },
    editExaminer: function (groupStaffId) {
      this.$refs.editExaminer.openEditUser(groupStaffId)
    },
    editExaminerDialog: function () {
      this.getVoteUserGroups()
    },
    exportTemplate: function () {
      const _this = this
      _this.openLoading()
      voteUserApi.exportWJUserTemplate({
        UserGroupID: _this.selectUserGroupId
      }).then(data => {
        if (!data) {
          return
        }
        let fileName = '答卷人员'
        if (_this.selectUserGroupId) {
          _this.userGroupList.forEach(function (item, index) {
            if (item.MeetingUserGroupID === _this.selectUserGroupId) {
              fileName = item.MeetingUserGroupName
            }
          })
        }
        const fileUrl = window.URL.createObjectURL(new Blob([data], { type: 'application/vnd.ms-excel;charset=utf-8' }))

        const elink = document.createElement('a')
        // 设置下载文件名
        elink.setAttribute('download', fileName + '.xls')
        elink.style.display = 'none'
        elink.href = fileUrl
        document.body.appendChild(elink)
        elink.click()

        document.body.removeChild(elink) // 下载完成移除元素
        window.URL.revokeObjectURL(fileUrl) // 释放掉blob对象
        _this.openLoading().close()
      }).catch(err => {
        _this.openLoading().close()
        return err
      })
    },
    editQuestionnaireUser: function (isNext) {
      const _this = this
      const openLoading = _this.openLoading('保存中…')
      const selectIds = []
      this.selectRows.map(item => {
        selectIds.push(item.GroupStaffID)
      })
      this.questionnaireUserInfo = {
        Id: this.$route.params.qid,
        SelectUserNum: this.selectRows.length,
        UserGroupId: this.selectUserGroupId,
        UserIds: selectIds
      }
      questionnaireApi.editQuestionnaireUser(this.questionnaireUserInfo).then(data => {
        this.voteCheck()
        openLoading.close()
        _this.$message({
          showClose: true,
          type: 'success',
          message: '保存成功！',
          customClass: 'custom_message'
        })
        if (isNext) {
          _this.$router.push({
            name: 'editVoteBody',
            params: { mid: _this.$route.params.mid, vid: _this.$route.params.vid, qid: _this.$route.params.qid }
          })
        }
      }).catch(err => {
        this.voteCheck()
        openLoading.close()
        return err
      })
    },
    deleteQuestionnaireUser: function (row) {
      const _this = this
      this.$confirm('确认从问卷删除该人员吗？姓名：' + row.UserName, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'custom_message_box'
      }).then(() => {
        const openLoading = _this.openLoading()
        questionnaireApi.adjustQuestionnaireUser({
          QuestionnaireId: _this.$route.params.qid,
          GroupStaffId: row.GroupStaffID,
          Action: 'Delete'
        }).then(data => {
          _this.getQuestionnaireUserInfo()
          openLoading.close()
        }).catch(err => {
          openLoading.close()
          return err
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消',
          customClass: 'custom_message'
        })
      })
    },
    insertQuestionnaireUser: function (row) {
      const _this = this
      this.$confirm('确认添加该人员吗？姓名：' + row.UserName, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'custom_message_box'
      }).then(() => {
        const openLoading = _this.openLoading()
        questionnaireApi.adjustQuestionnaireUser({
          QuestionnaireId: _this.$route.params.qid,
          GroupStaffId: row.GroupStaffID,
          Action: 'Insert'
        }).then(data => {
          _this.getQuestionnaireUserInfo()
          openLoading.close()
        }).catch(err => {
          openLoading.close()
          return err
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消',
          customClass: 'custom_message'
        })
      })
    }
  },
  computed: {

  },
  created () {
    this.meetingId = this.$route.params.mid
    this.groupListQuery.meetingId = this.$route.params.mid
    this.getVoteUserGroups()
    this.getCurrentUserRole()
    this.routeChange()
    this.voteCheck()
  }
}
</script>
<style lang="less">
</style>
